import { render, staticRenderFns } from "./ParticularDetails.vue?vue&type=template&id=11089456&"
import script from "./ParticularDetails.vue?vue&type=script&lang=js&"
export * from "./ParticularDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports